import { render, staticRenderFns } from "./beautifulTown.vue?vue&type=template&id=319a9e23&scoped=true"
import script from "./beautifulTown.vue?vue&type=script&lang=js"
export * from "./beautifulTown.vue?vue&type=script&lang=js"
import style0 from "./beautifulTown.vue?vue&type=style&index=0&id=319a9e23&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319a9e23",
  null
  
)

export default component.exports